import { useEffect } from "react";
import ShowroomList from "./components/showroom.list";
import { useDispatch } from "react-redux";
import { getShowroomList } from "../../redux/reducer/common.reducer";
import ShowroomHero from "./components/showroom.hero";
import ShowroomExpert from "./components/showroom.expert";

export default function Showroom() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getShowroomList());
  }, []);

  return (
    <article className="showroom">
      <ShowroomHero />
      <ShowroomExpert />
      <ShowroomList />
    </article>
  );
}
